import {
  error,
  ExternalCardFragment,
  tag,
  TransactionRowFragment,
  VerifyCardActionScreenFragment,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchExternalCardDetails = gql`
  query fetchExternalCardDetails($cardId: ID!) {
    externalCard(cardId: $cardId) {
      ... on ExternalCardError {
        ...error
      }
      ... on ExternalCardSuccess {
        externalCard {
          ...ExternalCardFragment
          tag {
            ...tag
          }
          inlineAlert {
            id
            title
            body
            buttonTitle
          }
          transactions {
            ... on SLTitledListComponent {
              id
              title {
                copy
              }
              children {
                ... on TransactionRowComponent {
                  ...TransactionRowFragment
                }
              }
            }
          }
          verifyCardActionScreen {
            ...verifyCardActionScreen
          }
        }
      }
      __typename
    }
  }
  ${ExternalCardFragment}
  ${error}
  ${tag}
  ${TransactionRowFragment}
  ${VerifyCardActionScreenFragment}
`;

export default FetchExternalCardDetails;
